import React from "react";
import { useTranslation } from "react-i18next";
import { Select } from "antd";
import { DownOutlined } from "@ant-design/icons";

const { Option } = Select;

const LANGUAGES = [
  {
    code: "tr",
    label: "Türkçe",
    icon: "/assets/images/turkey.png"
  },
  {
    code: "en",
    label: "English",
    icon: "/assets/images/united-kingdom.png"
  }
];

function LanguageSelector() {
  const { i18n } = useTranslation();
  const currentLang = i18n.language?.split("-")[0];

  const handleChange = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem("i18nextLng", lang);
  };

  return (
    <Select
      value={currentLang}
      onChange={handleChange}
      style={{ width: 60 }}
      dropdownAlign={{ offset: [0, 4] }}
      suffixIcon={<DownOutlined />}
      size="large"
    >
      {LANGUAGES.map((lang) => (
        <Option key={lang.code} value={lang.code}>
          <img
            src={lang.icon}
            alt={lang.label}
            style={{ width: 25, height: 25, display: "block", margin: "0 auto" }}
          />
        </Option>
      ))}
    </Select>
  );
}

export default LanguageSelector;
